import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import { useAccess } from '@/lib/access';

// «Tu zona: EZE» — why a zoned operator sees only some flights (PO 2026-10-28: «un operador
// con zona EZEIZA… debería ver solo llegadas y salidas de Ezeiza»). The BFF narrows every
// flight list and airport picker to the profile's airports; this line says so, so a short
// list never reads as missing data. Nothing for an operator of the whole airline.

export function ZoneNote() {
  const { t } = useTranslation('network');
  const { airports } = useAccess();
  if (airports === '*') return null;
  return (
    <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground" data-testid="zone-note">
      <MapPin aria-hidden className="h-3.5 w-3.5 shrink-0" />
      {airports.length > 0 ? t('board.zone', { list: airports.join(' · ') }) : t('board.zoneNone')}
    </p>
  );
}
